import { capitalize } from '@/utils/strings';
import { NumberOfRooms } from '../Store/utils';

export function getRoomSizeDescription(rooms: NumberOfRooms[] | null) {
  if (!rooms) {
    return 'Alla rum';
  }

  // Value is not null, but at the same time all romms are selected in the list
  const allRoomsSelected = Object.values(NumberOfRooms).every((roomOption) =>
    rooms.find((room) => room === roomOption),
  );
  if (allRoomsSelected) {
    return 'Alla rum';
  }

  if (rooms.length > 0) {
    const roomLabels = Object.values(NumberOfRooms)
      .filter((r) => rooms.includes(r))
      .map((room) => (room === NumberOfRooms.fivePlus ? '5+' : room));

    const str = roomLabels.join(', ').replace(/,(?!.*,)/gim, ' och');
    return `${capitalize(str)} rum`;
  }
}
